module.exports = __webpack_public_path__ + "static/media/uziemienie.62ba5ff7.jpg";